// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"f32734b0","455":"02d50b49","977":"d1a3af68"}[chunkId] + ".chunk.js";
};